export const extractShareCode = (search: string) => {
  const params = new URLSearchParams(search);
  return params.get('shareCode') || null;
};
